import gql from 'graphql-tag';

export const CREATE_DISCIPLINE = gql`
  mutation CreateDiscipline($input: DisciplineInput!) {
    createDiscipline(input: $input) {
      name
      description
      _id
    }
  }
`;

export const UPDATE_DISCIPLINE = gql`
  mutation UpdateDiscipline($id: MOID!, $input: UpdateDisciplineInput!) {
    updateDiscipline(id: $id, input: $input)
  }
`;

export const REMOVE_DISCIPLINE = gql`
  mutation RemoveDiscipline($id: MOID!) {
    removeDiscipline(id: $id)
  }
`;
